module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper contact-us-form",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v("Want to become a TONE Expert?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("TONE is a platform for women helping women in all areas of life. We look for experts in fields that can help\n                        women grow professionally and personally to live life to the fullest potential. Our experts are highly\n                        credentialed, successful in their fields and passionate about helping women. TONE underwrites production and\n                        related expenses, and experts are not paid a fee for their appearances. Please complete this form and tell us\n                        about yourself and why you would be a great addition to TONE")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "contactus_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "First Name",
      "autocomplete": "given-name",
      "type": "text",
      "error": "First Name",
      "placeholder": "First Name",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.firstName),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "firstName", $$v)
      },
      expression: "becomeExpert.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Last Name",
      "autocomplete": "family-name",
      "type": "text",
      "error": "Last Name",
      "placeholder": "Last Name",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.lastName),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "lastName", $$v)
      },
      expression: "becomeExpert.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Email Address",
      "autocomplete": "email",
      "id": "contactus_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.email),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "email", $$v)
      },
      expression: "becomeExpert.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "id": "contactus_phonenumber",
      "error": "Phone Number",
      "placeholder": "Phone Number",
      "mask": "\\(111) 111-1111",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.phone),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "phone", $$v)
      },
      expression: "becomeExpert.phone"
    }
  })], 1), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Preferred method to Reach to you",
      "type": "text",
      "error": "Reach Method",
      "placeholder": "Preferred method to Reach to you",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.reachMethod),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "reachMethod", $$v)
      },
      expression: "becomeExpert.reachMethod"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Website URL",
      "type": "text",
      "error": "Website",
      "placeholder": "Website URL",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.websiteUrl),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "websiteUrl", $$v)
      },
      expression: "becomeExpert.websiteUrl"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Facebook",
      "type": "text",
      "error": "Facebook",
      "placeholder": "Facebook"
    },
    model: {
      value: (_vm.becomeExpert.smFacebook),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smFacebook", $$v)
      },
      expression: "becomeExpert.smFacebook"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Instagram",
      "type": "text",
      "error": "Instagram",
      "placeholder": "Instagram"
    },
    model: {
      value: (_vm.becomeExpert.smInstagram),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smInstagram", $$v)
      },
      expression: "becomeExpert.smInstagram"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Twitter",
      "type": "text",
      "error": "Twitter",
      "placeholder": "Twitter"
    },
    model: {
      value: (_vm.becomeExpert.smTwitter),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smTwitter", $$v)
      },
      expression: "becomeExpert.smTwitter"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "LinkedIn",
      "type": "text",
      "error": "LinkedIn",
      "placeholder": "LinkedIn"
    },
    model: {
      value: (_vm.becomeExpert.smLinked_in),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smLinked_in", $$v)
      },
      expression: "becomeExpert.smLinked_in"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Pinterest",
      "type": "text",
      "error": "Pinterest",
      "placeholder": "Pinterest"
    },
    model: {
      value: (_vm.becomeExpert.smPinterest),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smPinterest", $$v)
      },
      expression: "becomeExpert.smPinterest"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Other",
      "type": "text",
      "error": "Other",
      "placeholder": "Other"
    },
    model: {
      value: (_vm.becomeExpert.smOther),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smOther", $$v)
      },
      expression: "becomeExpert.smOther"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "How did you hear about TONE?",
      "type": "text",
      "error": "Other",
      "placeholder": "How did you hear about TONE?"
    },
    model: {
      value: (_vm.becomeExpert.howHearTone),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "howHearTone", $$v)
      },
      expression: "becomeExpert.howHearTone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox text-left"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.toneMember),
      expression: "becomeExpert.toneMember"
    }],
    staticClass: "checkbox form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.toneMember) ? _vm._i(_vm.becomeExpert.toneMember, null) > -1 : (_vm.becomeExpert.toneMember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.toneMember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "toneMember", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "toneMember", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "toneMember", $$c)
        }
      }
    }
  }), _vm._v("\n                                Are you currently a TONE Member?\n                            ")])]), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Provide an overview of your professional experience and your bio",
      "type": "textarea",
      "error": "Professional Biography",
      "placeholder": "Provide an overview of your professional experience and your bio",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.bioProfExp),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "bioProfExp", $$v)
      },
      expression: "becomeExpert.bioProfExp"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Other info about you (e.g. speaking experiences, links to relevant material, publications, etc.)",
      "type": "textarea",
      "error": "Comments",
      "placeholder": "Other info about you (e.g. speaking experiences, links to relevant material, publications, etc.)"
    },
    model: {
      value: (_vm.becomeExpert.otherPersonalInfo),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "otherPersonalInfo", $$v)
      },
      expression: "becomeExpert.otherPersonalInfo"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "Tell us why you’d like to be a part of TONE",
      "type": "textarea",
      "error": "Join Reason",
      "placeholder": "Tell us why you’d like to be a part of TONE",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.joinReason),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "joinReason", $$v)
      },
      expression: "becomeExpert.joinReason"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "label": "What topics would you propose for your TONE videos?",
      "type": "textarea",
      "error": "Video Topics",
      "placeholder": "What topics would you propose for your TONE videos?",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.videoTopic),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "videoTopic", $$v)
      },
      expression: "becomeExpert.videoTopic"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto",
      "text-align": "left",
      "margin": "0 0 30px"
    }
  }, [_vm._v("\n                                Which content areas would your videos appear in? (check all that apply)\n                            "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentWork),
      expression: "becomeExpert.contentWork"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentWork) ? _vm._i(_vm.becomeExpert.contentWork, null) > -1 : (_vm.becomeExpert.contentWork)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentWork,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentWork", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentWork", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentWork", $$c)
        }
      }
    }
  }), _vm._v(" Work\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentLife),
      expression: "becomeExpert.contentLife"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentLife) ? _vm._i(_vm.becomeExpert.contentLife, null) > -1 : (_vm.becomeExpert.contentLife)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentLife,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentLife", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentLife", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentLife", $$c)
        }
      }
    }
  }), _vm._v(" Life\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentMind),
      expression: "becomeExpert.contentMind"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentMind) ? _vm._i(_vm.becomeExpert.contentMind, null) > -1 : (_vm.becomeExpert.contentMind)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentMind,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentMind", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentMind", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentMind", $$c)
        }
      }
    }
  }), _vm._v(" Mind/Body\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentMoney),
      expression: "becomeExpert.contentMoney"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentMoney) ? _vm._i(_vm.becomeExpert.contentMoney, null) > -1 : (_vm.becomeExpert.contentMoney)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentMoney,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentMoney", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentMoney", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentMoney", $$c)
        }
      }
    }
  }), _vm._v(" Money\n                                ")])])])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn formButton btn-transparent",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": _vm.spinner,
      "id": "contact_sendbutton"
    }
  }, [_vm._v("\n                                Send Request\n                                "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "0",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "contactus_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-476d1140", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476d1140"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/BecomeExpert.vue